export default "__VITE_ASSET__DLqigJ1i__"